import { render, staticRenderFns } from "./LeaderboardResults.vue?vue&type=template&id=375ff239&scoped=true&"
import script from "./LeaderboardResults.vue?vue&type=script&lang=js&"
export * from "./LeaderboardResults.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardResults.vue?vue&type=style&index=0&id=375ff239&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375ff239",
  null
  
)

export default component.exports